<script>
import * as echarts from 'echarts';
export default {
    props: {
        companyDialog: {
            type: Boolean,
            default: false
        },
        chartData: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        projectModel: {
            type: Object,
            default: null
        },
        headData: {
            type: Array,
            default: null
        },
        tableData: {
            type: Array,
            default: null
        },
        tablekey: {
            type: Number,
            default: null
        }
    },
    watch: {
        type: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {

                })
            }
        }
    },
    data() {
        return {
            gridData: [],
            largeSdseContainer: null,
            companyChartData: null,
            title: "",
        }
    },
    methods: {
        handleDialogOpened(){
            this.$nextTick(() => {
                if (this.type === "1") {
                    this.initWdse(this.chartData);
                    this.title = "公司维度税额情况表";
                } else if (this.type === "2") {
                    this.initWdts(this.chartData);
                    this.title = "公司维度增收节支情况表"
                } else if (this.type === "3") {
                    this.initSfqk(this.chartData);
                    this.title = "税负情况"
                } else if (this.type === "4") {
                    this.initXmzs(this.chartData);
                    this.title = "项目维度增收节支情况"
                } else {
                    this.title = "税收调研、核查频次情况表"
                }
            });
        },
        closediag(){
            this.$emit('closediag', false);
            if (this.largeSdseContainer) {
                this.largeSdseContainer.dispose()// 销毁实例
            }
        },
        initSfqk(chartData) {
            let xdata = [];
            let ydata = [];
            let dimensionTax = chartData;
            if (dimensionTax) {
                for (const key in dimensionTax) {
                    if (dimensionTax.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = dimensionTax[key];
                        xdata.push(key);
                        ydata.push(value);
                    }
                }
            }
            let chartDom = document.getElementById('largeSdseContainer');
            this.largeSdseContainer = echarts.init(chartDom);
            let option;

            option = {
                tooltip: { // 新增悬浮提示配置
                    trigger: 'axis', // 触发方式（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 指示器类型（可选：'line'|'shadow'|'none'）
                    },
                    formatter: '{b}<br/>税负情况: {c}' // 自定义提示内容格式
                    // 默认格式也可直接使用，无需formatter
                },
                xAxis: {
                    type: 'category',
                    data: xdata,
                    axisLabel: {
                        color: '#999999' // x轴刻度文字颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#6E7079' // x轴线颜色
                        }
                    },
                    name: '（公司）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            type: 'dashed', // 全局设置为虚线
                            color: '#E5E5E5' // 虚线颜色（可选）
                        },
                        // 特殊处理最底部实线
                        show: (params) => params.value !== 0 // 假设0是最底部刻度
                    },
                    axisLine: {
                        show: false // 隐藏y轴竖线
                    },
                    axisLabel: {
                        color: '#999999' // y轴刻度文字颜色
                    },
                    name: '比例：%',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                series: [
                    {
                        data: ydata,
                        type: 'line',
                        itemStyle: {
                            color: '#0065B1' // 数据点颜色（更新为#0065B1）
                        },
                        lineStyle: {
                            color: '#0065B1' // 线条颜色（更新为#0065B1）
                        }
                    }
                ]
            };

            option && this.largeSdseContainer.setOption(option);
        },
        initXmzs(chartData) {
            let xdata = [];
            let ydata = [];
            let data = chartData;
            if (data) {
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = data[key];
                        xdata.push(value);
                        ydata.push(this.projectModel[key]);
                    }
                }
            }
            let chartDom = document.getElementById('largeSdseContainer');
            this.largeSdseContainer = echarts.init(chartDom);
            let option;

            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    axisLine: {
                        show: false // 隐藏 x 轴基线（最下面的横线）
                    },
                    axisTick: {
                        show: false // 隐藏 x 轴刻度线
                    },
                    axisLabel: {
                        color: '#999999' // x轴刻度文字颜色
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed', // 横向网格线改为虚线
                            color: '#E5E5E5' // 虚线颜色
                        }
                    },
                    name: '（万元）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, 0, 0, -40]
                    },
                },
                yAxis: {
                    type: 'category',
                    data: ydata,
                    axisLine: {
                        show: false // 隐藏 y 轴基线
                    },
                    axisLabel: {
                        color: '#999999' // x轴刻度文字颜色
                    },
                    axisTick: {
                        show: false // 隐藏 y 轴刻度线
                    },
                    name: '（政策）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, 0, -10, -40]
                    },
                },
                series: [
                    {
                        name: '',
                        type: 'bar',
                        barWidth: '45%', // 调整柱子宽度（原默认约60%）
                        data: xdata,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0, // 渐变方向（从左到右）
                                [

                                    { offset: 0, color: '#0065B1' },  // 结束颜色（蓝色）
                                    { offset: 1, color: '#7BC0F5' } // 起始颜色（白色）
                                ]
                            ),
                            borderRadius: [0, 20, 20, 0] // 顶部圆角（右侧两个角）
                        }
                    }
                ]
            };

            option && this.largeSdseContainer.setOption(option);
        },
        initWdts(chartData) {
            let chartDom = document.getElementById('largeSdseContainer');
            this.largeSdseContainer = echarts.init(chartDom);
            let option;
            let xdata = [];
            let ydata = [];
            let data = chartData;
            if (data) {
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = data[key];
                        xdata.push(key);
                        ydata.push(value);
                    }
                }
            }
            option = {
                xAxis: {
                    type: 'category',
                    data: xdata,
                    // 关键设置：横向刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 统一为灰色
                    },
                    name: '（公司）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                yAxis: {
                    type: 'value',
                    // 隐藏左侧竖线（Y轴轴线）
                    axisLine: {
                        show: false // 关键配置
                    },
                    // 修改刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 刻度值颜色
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed', // 全局设置为虚线
                            color: '#E5E5E5' // 虚线颜色（可选）
                        },
                        // 特殊处理最底部实线
                        show: (params) => params.value !== 0 // 假设0是最底部刻度
                    },
                    name: '金额：万元', // 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, 0, 0, 0]
                    },
                },
                series: [{
                    data: ydata,
                    type: 'bar',
                    barWidth: '50%',
                    itemStyle: {
                        color: '#0065B1' // 直接指定颜色
                    }
                }]
            };
            option && this.largeSdseContainer.setOption(option);
        },
        initWdse(chartData) {
            let xdata = [];
            let ydata = [];
            let dimensionTax = chartData;
            if (dimensionTax) {
                for (const key in dimensionTax) {
                    if (dimensionTax.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = dimensionTax[key];
                        xdata.push(key);
                        ydata.push(value);
                    }
                }
            }
            let chartDom = document.getElementById('largeSdseContainer');
            this.largeSdseContainer = echarts.init(chartDom);

            let option;

            option = {
                xAxis: {
                    type: 'category',
                    data: xdata,
                    // 关键设置：横向刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 统一为灰色
                    },
                    name: '（公司）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                yAxis: {
                    type: 'value',
                    // 隐藏左侧竖线（Y轴轴线）
                    axisLine: {
                        show: false // 关键配置
                    },
                    // 修改刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 刻度值颜色
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed', // 全局设置为虚线
                            color: '#E5E5E5' // 虚线颜色（可选）
                        },
                        // 特殊处理最底部实线
                        show: (params) => params.value !== 0 // 假设0是最底部刻度
                    },
                    name: '缴款金额：万元', // 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, -20, 0, 0]
                    },
                },
                series: [{
                    data: ydata,
                    type: 'bar',
                    barWidth: '50%',
                    itemStyle: {
                        color: '#5B96FF' // 直接指定颜色
                    }
                }]
            };
            option && this.largeSdseContainer.setOption(option);
        },
    }
};
</script>

<template src="./index.html">

</template>

<style scoped lang="less">
@import "./index.less";
</style>